/**
 * Step 3: Configure Gates
 * Set up optional disbursement policies for value flows.
 */
import type React from "react";
import { GateConfigCard } from "../shared";

export interface ConfigureGatesStepProps {
  links: Array<{ id: string; source_id: string; target_id: string; link_type: string }>;
  gateConfigs: Record<string, { type: string; config: Record<string, unknown> }>;
  setGateConfig: (
    linkId: string,
    config:
      | { type: "multisig" | "whitelist" | "rate_limit"; config: Record<string, unknown> }
      | undefined,
  ) => void;
}

export const ConfigureGatesStep: React.FC<ConfigureGatesStepProps> = ({
  links,
  gateConfigs,
  setGateConfig,
}) => (
  <div>
    <div className="mb-4">
      <p className="text-sm text-sa-text-muted">
        Configure optional disbursement gates for value flows. Signal flows don&apos;t require
        gates.
      </p>
    </div>

    {links.filter((l) => l.link_type === "value").length === 0 ? (
      <div className="p-6 bg-sa-surface-hover rounded-lg text-center">
        <p className="text-sa-text-muted">
          No value flows to configure. Signal flows are free and don&apos;t require gates.
        </p>
      </div>
    ) : (
      <div className="space-y-4">
        {links
          .filter((l) => l.link_type === "value")
          .map((link) => (
            <GateConfigCard
              key={link.id}
              link={link}
              currentType={gateConfigs[link.id]?.type}
              onSetGate={setGateConfig}
            />
          ))}
      </div>
    )}
  </div>
);
